import * as React from 'react';
import { useEffect, useState } from 'react';
import {
 Box,
 Button,
 TextField,
 Alert,
 Snackbar,
 MenuItem,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker'; // Бесплатный DatePicker v5
import { useMutation, useQueryClient } from 'react-query';
import dayjs, { Dayjs } from 'dayjs';
import { ruRU } from '@mui/x-date-pickers/locales';
import { ContentWrapper } from '../../_common';
import SelectContract from '../../_common/SelectContract';
import srv from '../../../services';
import SuccessModal from './Modal/SuccessModal';
import ruLocale from 'dayjs/locale/ru';
import { makeStyles } from '@material-ui/core/styles';
import { SubmitButton } from './AgreementDocuments.styled';

const useStyles = makeStyles({
 docType: {
  width: '380px',
  marginLeft: '-26px !Important',
  '& .MuiInputBase-root': {
   height: '32px !Important',
   fontSize: '12px !Important',
  },
  '& .MuiSelect-select': {
   fontSize: '12px !Important',
  },
  '& .MuiInputLabel-root': {
   fontSize: '12px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
 menuItem: {
  fontSize: '12px !Important',
  paddingY: '6px !Important',
 },
 email: {
  width: '260px',
  marginLeft: '-6px !Important',
  '& .MuiInputBase-root': {
   height: '32px',
   fontSize: '13px',
  },
  '& .MuiSelect-select': {
   fontSize: '13px',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
 datePicker: {
  width: '380px',
  '& .MuiInputBase-root': {
   height: '32px',
   fontSize: '13px',
  },
  '& .MuiSelect-select': {
   fontSize: '13px',
  },
  '& .MuiInputLabel-root': {
   fontSize: '13px',
   transform: 'translate(14px, 8px) scale(1)',
  },
  '& .MuiInputLabel-shrink': {
   transform: 'translate(14px, -6px) scale(0.75)',
  },
  '& .MuiFormHelperText-root': {
   fontSize: '10px',
  },
 },
});

const AgreementDocuments = () => {
 const {
  contracts,
  contractAisId,
  docConnection,
  buttonVisible,
  mail,
  startDate,
  endDate,
  visible,
  data,
  errors,
  notification,
  changeContract,
  changeDocConnection,
  setStartDate,
  setEndDate,
  changeEmail,
  handleCancel,
  handleCloseNotification,
  onFinish,
 } = useConnection();

 const classes = useStyles();

 return (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
   <ContentWrapper>
    <Box
     component="form"
     noValidate
     autoComplete="off"
     sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 3 }}
    >
     <Box
      sx={{
       display: 'flex',
       flexDirection: 'row',
       gap: 2,
       alignItems: 'flex-start',
      }}
     >
      <div style={{ height: '100px !important' }}>
       <Box>
        <SelectContract
         changeContract={changeContract}
         contracts={contracts}
         value={contractAisId}
        />
       </Box>
      </div>

      <TextField
       size="small"
       select
       label="Тип документа"
       value={docConnection || ''}
       onChange={(e) => changeDocConnection(e.target.value)}
       error={!!errors.docConnection}
       helperText={errors.docConnection}
       className={classes.docType}
      >
       <MenuItem value="" disabled className={classes.menuItem}>
        Выберите тип документа
       </MenuItem>
       <MenuItem value="9" className={classes.menuItem}>
        Договор
       </MenuItem>
       <MenuItem value="10" className={classes.menuItem}>
        Дополнительное соглашение
       </MenuItem>
       <MenuItem value="11" className={classes.menuItem}>
        Акт разграничения балансовой принадлежности
       </MenuItem>
      </TextField>
     </Box>

     {/* Вторая строка: Период (v5 renderInput), Email и Кнопка */}
     <Box
      sx={{
       display: 'flex',
       flexDirection: 'row',
       gap: 2,
       alignItems: 'flex-start',
      }}
     >
      <Box sx={{ display: 'flex', gap: 1, width: '400px' }}>
       <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={ruLocale}
       >
        <DatePicker
         label="Начало периода"
         inputFormat="DD.MM.YYYY"
         value={startDate}
         onChange={(newValue) => setStartDate(newValue)}
         renderInput={(params) => (
          <TextField
           {...params}
           size="small"
           error={!!errors.range}
           helperText={errors.range}
           fullWidth
           className={classes.datePicker}
          />
         )}
        />
       </LocalizationProvider>

       <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={ruLocale}
       >
        <DatePicker
         label="Окончание периода"
         inputFormat="DD.MM.YYYY"
         value={endDate}
         onChange={(newValue) => setEndDate(newValue)}
         renderInput={(params) => (
          <TextField
           {...params}
           error={!!errors.range}
           fullWidth
           size="small"
           className={classes.datePicker}
          />
         )}
        />
       </LocalizationProvider>
      </Box>

      <Box sx={{ width: '260px' }}>
       <TextField
        size="small"
        fullWidth
        label="E-mail"
        placeholder="example@mail.com"
        value={mail || ''}
        onChange={changeEmail}
        error={!!errors.mail}
        helperText={errors.mail}
        className={classes.email}
       />
      </Box>

      {buttonVisible && (
       <SubmitButton size="small" variant="contained" onClick={onFinish}>
        Запросить
       </SubmitButton>
      )}
     </Box>
     <SuccessModal visible={visible} handleCancel={handleCancel} data={data} />
     <Snackbar
      open={notification.open}
      autoHideDuration={7000}
      onClose={handleCloseNotification}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
     >
      <Alert
       onClose={handleCloseNotification}
       severity="error"
       sx={{ width: '100%' }}
      >
       {notification.message}
      </Alert>
     </Snackbar>
    </Box>
   </ContentWrapper>
  </LocalizationProvider>
 );
};

function useConnection() {
 const queryClient = useQueryClient();
 const contracts = queryClient.getQueryData<any[]>('contracts') || [];

 const [contractAisId, setContractAisId] = useState<number | null>(null);
 const [startDate, setStartDate] = useState<Dayjs | null>(null);
 const [endDate, setEndDate] = useState<Dayjs | null>(null);
 const [mail, setMail] = useState<string>('');
 const [docConnection, setDocConnection] = useState<string | null>(null);
 const [buttonVisible, setButtonVisible] = useState<boolean>(false);
 const [visible, setVisible] = useState<boolean>(false);

 const [errors, setErrors] = useState<{ [key: string]: string }>({});
 const [notification, setNotification] = useState({ open: false, message: '' });

 const contractId = contracts.find((i) => i.id === contractAisId);

 useEffect(() => {
  if (contractAisId && docConnection && startDate && endDate && mail) {
   setButtonVisible(true);
  } else {
   setButtonVisible(false);
  }
 }, [contractAisId, docConnection, startDate, endDate, mail]);

 const resetFormFields = () => {
  setStartDate(null);
  setEndDate(null);
  setMail('');
  setDocConnection(null);
  setErrors({});
 };

 const changeContract = (value: number) => {
  setContractAisId(value);
  resetFormFields();
 };

 const changeDocConnection = (value: string) => {
  setDocConnection(value);
  setStartDate(null);
  setEndDate(null);
  setMail('');
  setErrors((prev) => ({ ...prev, docConnection: '' }));
 };

 const changeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
  setMail(e.target.value);
  setErrors((prev) => ({ ...prev, mail: '' }));
 };

 const showModal = () => setVisible(true);
 const handleCancel = () => setVisible(false);

 const handleCloseNotification = () => {
  setNotification({ open: false, message: '' });
 };

 const { data, mutate: save } = useMutation(srv.requestDocuments, {
  onSuccess: () => {
   resetFormFields();
   setContractAisId(null);
   showModal();
  },
  onError: (errorMessage: any) => {
   setNotification({
    open: true,
    message: errorMessage || 'Произошла ошибка при запросе',
   });
  },
 });

 const onFinish = () => {
  const newErrors: { [key: string]: string } = {};

  if (!docConnection) newErrors.docConnection = 'Выберите тип документа';
  if (!startDate || !endDate) newErrors.range = 'Выберите период';
  if (!mail) newErrors.mail = 'Введите E-mail';

  if (Object.keys(newErrors).length > 0) {
   setErrors(newErrors);
   return;
  }

  const formattedStartDate = startDate?.format('YYYY-MM-DDTHH:mm:ss.SSS');
  const formattedEndDate = endDate?.format('YYYY-MM-DDTHH:mm:ss.SSS');
  const docType: number[] = [Number(docConnection)];

  const emailCheck = String(mail)
   .toLowerCase()
   .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
   );

  if (emailCheck) {
   save({
    contractId: contractId?.aisId,
    eMail: mail,
    documentsType: docType,
    startDate: formattedStartDate,
    endDate: formattedEndDate,
   });
  } else {
   setErrors((prev) => ({ ...prev, mail: 'Неверный адрес электронной почты' }));
   setNotification({
    open: true,
    message: 'Неверный адрес электронной почты',
   });
  }
 };

 return {
  onFinish,
  contracts,
  contractAisId,
  changeContract,
  changeDocConnection,
  changeEmail,
  buttonVisible,
  docConnection,
  contractId: contractId?.aisId,
  handleCancel,
  handleCloseNotification,
  visible,
  data,
  mail,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  errors,
  notification,
 };
}

export default AgreementDocuments;
